import { Controller } from "@hotwired/stimulus"

// Submits the surrounding form when a field changes (template / paper size pickers).
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
